import { Box, Button, FormControl, Grid, IconButton, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography } from '@mui/material';
import { TEXT_LIGHT_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import { usePopUpFormManageControllers } from './controller/form';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddIcon from '@mui/icons-material/Add';
import { PopupSlideEnum, PopupTypeEnum } from '../../enums/popupTypeEnum';
import { convertPopupTypeToString } from '../../utils/convertPopupTypeToString';
import ErrorMessageComponent from '../../components/errorMessage';
import ConfirmDialog from '../../components/ConfirmDialog';
import { PopupModel } from '../../models/popup';
import { useTranslation } from 'react-i18next';
import { MerChantModel } from '../../models/merChantModel';
import { TagPromotionModel } from '../../models/tagPromotion.model';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import i18next from 'i18next';
import { getLanguageLabel } from '../../utils/getLanguageLabel';
import { MainGroupModel } from '../../models/mainGroup';
import { DivisionModel } from '../../models/division';
import { CategoriesModel } from '../../models/categories';
import { SubCategoryModel } from '../../models/subCategory';
import { ProductMerchantModel } from '../../models/productMerchant';
import SearchIcon from '@mui/icons-material/Search';
interface Props {
  onClose: VoidFunction;
  popupType: PopupTypeEnum;
  onFetchData: Function;
  selectedData: PopupModel;
  branchData: MerChantModel[];
  tagData: TagPromotionModel[];
}

const FormPopUpManageView = ({ onClose, popupType, onFetchData, selectedData, branchData, tagData }: Props) => {
  const { t } = useTranslation('global');
  const controller = usePopUpFormManageControllers({ selectedData: selectedData, onFetchData, onClose, popupType });
  const isDisabled = !!selectedData;
  
  const renderCategorySection = () => {
    if (controller.loadingCategories) return <LinearProgress />;
    if (popupType === PopupTypeEnum.COUPON || popupType === PopupTypeEnum.PROMOTION) return null;
    if (selectedData?.subCategoryId === null) return null;

    return (
      <>
        {/* Category main group */}
        {controller.mainGroupData?.length > 0 && (
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="Branch-label-id">{t('popup_page.Main Group')}</InputLabel>
              <Select
                size="small"
                id="select-main-group-id"
                label={t('popup_page.Main Group')}
                disabled={!selectedData ? selectedData : true}
                sx={{ borderRadius: '8px' }}
                value={controller.selectedMainCategory}
                onChange={controller.handleSelectMainGroup}                                
              >
                {controller.mainGroupData?.map((item: MainGroupModel) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {i18next.language === EN_ACCEPT_LANGUAGE
                      ? item?.supplies_main_group_name?.main_group_name_en
                      : item?.supplies_main_group_name?.main_group_name_la}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
         
        {/* Category division */}
        {controller.divisionData?.length > 0 && (
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="Branch-label-id">{t('popup_page.Division')}</InputLabel>
              <Select
                size="small"
                id="select-division-id"
                sx={{ borderRadius: '8px' }}
                label={t('popup_page.Division')}
                disabled={!selectedData ? selectedData : true}
                value={controller.selectedDivision}
                onChange={controller.handleSelectDivision}
              >
                {controller.divisionData?.map((item: DivisionModel) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {i18next.language === EN_ACCEPT_LANGUAGE
                      ? item?.supplies_division_name?.division_name_en
                      : item?.supplies_division_name?.division_name_la}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
         
        {/* Categories data */}
        {controller.categoriesData?.length > 0 && (
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="Branch-label-id">{t('popup_page.Categories')}</InputLabel>
              <Select
                size="small"
                id="select-division-id"
                sx={{ borderRadius: '8px' }}
                label={t('popup_page.Categories')}
                disabled={!selectedData ? selectedData : true}
                value={controller.selectedCategories}
                onChange={controller.handleSelectCategories}
              >
                {controller.categoriesData?.map((item: CategoriesModel) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {i18next.language === EN_ACCEPT_LANGUAGE
                      ? item?.supplies_product_category?.category_name_en
                      : item?.supplies_product_category?.category_name_la}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* Sub categories */}
        {controller.subCategoryData?.length > 0 && (
          <Grid item xs={6}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="Branch-label-id">{t('popup_page.Sub Categories')}</InputLabel>
              <Select
                size="small"
                id="select-division-id"
                sx={{ borderRadius: '8px' }}
                label={t('popup_page.Sub Categories')}
                disabled={!selectedData ? selectedData : true}
                value={controller.selectedSubCategory}
                onChange={controller.handleSelectSubCategory}                
              >
                {controller.subCategoryData?.map((item: SubCategoryModel) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {getLanguageLabel(
                      item?.supplies_product_sub_category?.sub_category_name_en,
                      item?.supplies_product_sub_category?.sub_category_name_la
                    )}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </>
    );
  };

  const renderProductSearchSection = () => {
    return (
      <>
        {/* Search product */}
        {controller.selectedTypePopup === PopupSlideEnum.PRODUCT_DETAIL && (
          <Grid item xs={6}>
            <TextField
              fullWidth
              size="small"
              margin="normal"
              label={t('banner_page.Search Product')}
              inputRef={controller.itemProductCodeRef}
              disabled={isDisabled}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderRadius: '8px',
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={controller.handleGetProductCode}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        )}
        {controller.productData?.length > 0 && (
          <Grid item xs={6}>
            <Box sx={{ width: '100%' }}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel id="Branch-label-id">{t('popup_page.Select product')}</InputLabel>
                <Select
                  size="small"
                  id="select-product-id"
                  sx={{ borderRadius: '8px' }}
                  label={t('popup_page.Select product')}
                  disabled={isDisabled}
                  value={controller.selectedProductValue}
                  onChange={controller.handleSelectedProduct}            
                >
                  {controller.productData?.map((item: ProductMerchantModel) => (
                    <MenuItem key={item?.id} value={item?.id}>
                      {i18next.language === EN_ACCEPT_LANGUAGE
                        ? item?.price?.masterProduct?.productNameEn
                        : item?.price?.masterProduct?.productNameLa}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        )}
      </>
    );
  };

  const renderTagPromotionSection = () => {
    return (
      <>
        <Grid item xs={6}>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel id="Branch-label-id">{t('banner_page.Select Tag Promotion')}</InputLabel>
            <Select
              size="small"
              id="select-tag-pro-id"
              sx={{ borderRadius: '8px' }}
              label={t('banner_page.Select Tag Promotion')}
              disabled={isDisabled}
              value={controller.selectedTagPromotion}
              onChange={controller.handleSelectTagPromotion}
            >
              {tagData.map((item: TagPromotionModel) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.tagName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </>
    );
  };

  const FormSection = () => {
    switch (controller.selectedTypePopup) {
      case PopupSlideEnum.CATEGORY:
        return renderCategorySection();
      case PopupSlideEnum.PRODUCT_DETAIL:
        return renderProductSearchSection();
      case PopupSlideEnum.PROMOTION_FLASH_SALE:
        return renderTagPromotionSection();
      default:
        return null;
    }
  };

  const FormPromotionAndCouponSection = () => {
    switch (popupType) {
      case PopupTypeEnum.PROMOTION:
        return renderTagPromotionSection();
      default:
        return null;
    }
  };

  return (
    <Box>
      <IconButton onClick={onClose} sx={{ mb: 2 }}>
        <KeyboardBackspaceIcon />
      </IconButton>
      <Typography variant="h4" color={TEXT_TITLE_COLOR} sx={{ mb: 4 }}>
        {selectedData ? t('popup_page.Update pop-up') : t('popup_page.Create pop-up')}
      </Typography>

      <Box sx={{ maxWidth: 750 }}>
        <form onSubmit={controller.handleSubmit}>
          <Box sx={{ p: 4, boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)' }} >
            <Typography sx={{ mb: 2, color: 'red' }}>
              <span style={{ color: 'black' }}>{t('banner_page.Type')}: </span>
              {t(`popup_page.${convertPopupTypeToString(popupType)}`)}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField 
                  fullWidth size="small" margin="normal" type="date"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px'} }}
                  label={t('popup_page.Start Date')}
                  inputRef={controller.startDateRef}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ width: '100%' }}>
                  <TextField
                    fullWidth size="small" margin="normal" type="date"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px'} }}
                    label={t('popup_page.End Date')}
                    inputRef={controller.endDateRef}
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </Grid>

              {/* Popup Type */}
              <Grid item xs={6}>
                <Box sx={{ width: '100%' }}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel id="Branch-label-id">
                      {t('popup_page.Select popup type')}
                    </InputLabel>
                    <Select
                      size="small"
                      id="select-banner-type-id"
                      sx={{ borderRadius: '8px' }}
                      label={t('popup_page.Select popup type')}
                      disabled={isDisabled}
                      value={controller.selectedTypePopup}
                      onChange={controller.handleSelectedPopupType}     
                    >
                      {Object.values(PopupSlideEnum).map((value) => (
                        <MenuItem key={value} value={value}>
                          {t(`popup_page.${value}`)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              {/* Select Merchant */}
              <Grid item xs={6}>
                <Box sx={{ width: '100%' }}>
                  <FormControl fullWidth margin="normal" size="small">
                    <InputLabel id="Branch-label-id">{t('coupon_page.Branch')}</InputLabel>
                    <Select
                      size="small"
                      id="Branch-label-id"
                      sx={{ borderRadius: '8px' }}
                      label={t('coupon_page.Branch')}
                      value={controller.selectedMerchantValue}
                      onChange={controller.handleSelectedMerchant}                      
                      disabled={!selectedData ? selectedData : true}
                    >
                      {branchData?.map((item: MerChantModel) => (
                        <MenuItem key={item?.id} value={item?.id || ''}>
                          {i18next.language === EN_ACCEPT_LANGUAGE ? item?.nameEn : item?.nameLa}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <FormSection />
              <FormPromotionAndCouponSection />

            </Grid>

            <ErrorMessageComponent errorMessage={controller.errorMessage} />
            <Box mt={2}>
              <Button
                type="submit"
                variant="contained"
                sx={{ textTransform: 'none', width: 120, background: '#11A2F1', borderRadius: '10px' }}
              >
                {selectedData ? t('Update') : t('Create')}
              </Button>
            </Box>
          </Box>
        </form>
      </Box>

      {/* select image */}

      <Box sx={{ maxWidth: !controller.imageToShow ? 750 : null }}>
        <Typography sx={{ mt: 2 }}>{t('popup_page.1280 x 2275 is suitable for app')}</Typography>
        <Box sx={{ paddingTop: 5, paddingBottom: 5, mt: 3, backgroundColor: '#F4F6F8', borderRadius: '8px', border: '1px dashed rgba(145, 158, 171, 0.32);' }} >
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <label htmlFor="image-input-popup">
              <Box sx={{ cursor: 'pointer' }}>
                {controller.imageToShow ? (
                  <img
                    alt=""
                    src={controller.imageToShow}
                    style={{ width: 'auto', height: '640px', maxWidth: '360px', maxHeight: '640px', borderRadius: '16px', objectFit: 'cover' }}
                  />
                ) : (
                  <Box sx={{ width: 179, height: 164, backgroundColor: '#EBEBEB', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
                    <AddIcon sx={{ fontSize: 45, color: '#9C9C9C' }} />
                    <Typography color={TEXT_LIGHT_COLOR}>{t('popup_page.Add image')}</Typography>
                  </Box>
                )}
              </Box>
            </label>
            <input
              type="file"
              accept="image/*"
              id="image-input-popup"
              style={{ display: 'none' }}
              onChange={controller.handleSelectImage}
              onClick={(e: any) => {
                e.target.value = '';
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box>
        <ConfirmDialog
          open={controller.openConfirmDialog}
          title={`${t('popup_page.Do you want to')}${controller.selectedData ? t('popup_page.Update') : t('popup_page.Create pop-up')}?`}
          loading={controller.loadingSubmit}
          onCancel={() => controller.handleSetOpenConfirmDialog(false)}
          onConfirm={() => controller.handleConfirmDialog()}
        />
      </Box>
    </Box>
  );
};
export default FormPopUpManageView;
